module.exports = __webpack_public_path__ + "img/Action_plan_cards.e197cd71.png";